'use client';

import React, { useEffect, useState } from 'react';

import type { TimeChartItem } from 'src/types/chart';
import ChartWidget from 'src/components/chart/ChartWidget';

const TaskVolumeChart: React.FC = () => {
  const [ items, setItems ] = useState<Array<TimeChartItem>>([]);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ isError, setIsError ] = useState(false);

  useEffect(() => {
    fetch('https://management-backend.opengpu.network/api/dashboard/stats')
      .then((res) => res.json())
      .then((data) => {
        const raw = data?.data?.formattedDailyTasksData;
        if (Array.isArray(raw)) {
          const today = new Date();
          const cutoff = today.toISOString().slice(0, 10);
          const chartItems: Array<TimeChartItem> = raw
            .filter((item: { name: string }) => item.name < cutoff)
            .map((item: { name: string; tasks: number }) => ({
              date: new Date(item.name),
              value: item.tasks,
            }));
          setItems(chartItems.slice(-15));
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsError(true);
        setIsLoading(false);
      });
  }, []);

  return (
    <ChartWidget
      items={ items }
      title="Task Volume by Date"
      description="Number of tasks processed per day"
      isLoading={ isLoading }
      isError={ isError }
    />
  );
};

export default TaskVolumeChart;
